<template>
	<div
		class="pseudo-input"
		v-if="grade && ('marks' in grade)"
	>
		<input
			type="search"
			class="input-bare w-full flex-1"
			placeholder="Select"
			v-if="!grade.marks.length"
			@click="openGradeValuesModal()"
		/>
		<span
			class="badge badge-secondary badge-sm mr-2 mb-2"
			v-for="(mark, index) in grade.marks"
			v-bind:key="index"
		>
			{{getGradeValueCaption(mark)}}
			<a @click="removeGradeValue(mark)"><b-icon icon="x"></b-icon></a>
		</span>
		<span
			class="badge badge-primary badge-sm mr-2 mb-2"
			v-if="grade.marks.length"
			@click="openGradeValuesModal()"
		>
			<b-icon icon="plus"></b-icon> {{ $t("add") }}
		</span>
	</div>
</template>

<script>
export default {
	props: {
		grade: Object
	},
	data: function() {
		return {
			gradeconfig: []
		}
	} ,
	mounted() {
		this.getGradeConfig();
	},
	methods: {
		getGradeConfig() {
			this.gradeconfig = [];
			var assessmentfields = this.$config.getValue("assessmentfields");
			for(var sectionid in assessmentfields){
				assessmentfields[sectionid].forEach(grade => {
					if(grade.id == this.grade.id){
						this.gradeconfig = JSON.parse(JSON.stringify(grade));
					}
				});
			};
			var procedureassessmentfields = this.$config.getValue("proceduremarking");
			if(procedureassessmentfields && 'fields' in procedureassessmentfields){
				procedureassessmentfields.fields.forEach(grade => {
					if(grade.id == this.grade.id){
						this.gradeconfig = JSON.parse(JSON.stringify(grade));
					}
				});
			};
		},
		openGradeValuesModal() {
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: 'Select',
				selectCallback: function(selection) {
					const isSelected = self.grade.marks.find((option, i) => {
						if (option === selection.value) {
							self.$delete(self.grade.marks, i);
							return true;
						}
					});
					if (!isSelected) {
						self.grade.marks.push(selection.value);
					}
				},
				selected: this.grade.marks,
				data: this.gradeconfig.values,
				idProperty: 'value',
				captionKey: "caption"
			});
		},

		removeGradeValue(selection) {
			this.grade.marks.forEach((mark, i) => {
				if (mark === selection) {
					this.$delete(this.grade.marks, i);
					return true;
				}
			});
			return false;
		},

		getGradeValueCaption(selection) {
			var caption = '';
			if('values' in this.gradeconfig && this.gradeconfig.values.length){
				this.gradeconfig.values.forEach((option) => {
					if (option.value === selection) {
						caption = option.caption;
					}
				});
			}
			return caption;
		}
	},
	computed: {
	}
};
</script>
